<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <path
      d="M89.4001 78.9472C89.3978 79.7994 89.0582 80.616 88.4556 81.2187C87.853 81.8213 87.0363 82.1609 86.1841 82.1632H13.8161C12.9639 82.1609 12.1472 81.8213 11.5446 81.2187C10.942 80.616 10.6024 79.7994 10.6001 78.9472V27.4858H89.4001V78.9472Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M89.4001 27.486H10.6001V21.0529C10.6024 20.2007 10.942 19.3841 11.5446 18.7815C12.1472 18.1788 12.9639 17.8393 13.8161 17.8369H86.1841C87.0363 17.8393 87.853 18.1788 88.4556 18.7815C89.0582 19.3841 89.3978 20.2007 89.4001 21.0529V27.486Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.8159 22.6612C13.8159 22.8725 13.8575 23.0816 13.9384 23.2768C14.0192 23.4719 14.1377 23.6493 14.287 23.7986C14.4364 23.948 14.6137 24.0665 14.8089 24.1473C15.004 24.2281 15.2132 24.2697 15.4244 24.2697C15.6357 24.2697 15.8448 24.2281 16.04 24.1473C16.2351 24.0665 16.4124 23.948 16.5618 23.7986C16.7112 23.6493 16.8297 23.4719 16.9105 23.2768C16.9913 23.0816 17.0329 22.8725 17.0329 22.6612C17.0329 22.2346 16.8635 21.8255 16.5618 21.5239C16.2602 21.2222 15.851 21.0527 15.4244 21.0527C14.9978 21.0527 14.5887 21.2222 14.287 21.5239C13.9854 21.8255 13.8159 22.2346 13.8159 22.6612Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.249 22.6612C20.249 23.0878 20.4185 23.497 20.7201 23.7986C21.0218 24.1003 21.4309 24.2697 21.8575 24.2697C22.2841 24.2697 22.6933 24.1003 22.9949 23.7986C23.2966 23.497 23.466 23.0878 23.466 22.6612C23.466 22.2346 23.2966 21.8255 22.9949 21.5239C22.6933 21.2222 22.2841 21.0527 21.8575 21.0527C21.4309 21.0527 21.0218 21.2222 20.7201 21.5239C20.4185 21.8255 20.249 22.2346 20.249 22.6612Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.6812 22.6612C26.6812 23.0878 26.8506 23.497 27.1523 23.7986C27.4539 24.1003 27.8631 24.2697 28.2897 24.2697C28.7163 24.2697 29.1254 24.1003 29.427 23.7986C29.7287 23.497 29.8982 23.0878 29.8982 22.6612C29.8982 22.2346 29.7287 21.8255 29.427 21.5239C29.1254 21.2222 28.7163 21.0527 28.2897 21.0527C27.8631 21.0527 27.4539 21.2222 27.1523 21.5239C26.8506 21.8255 26.6812 22.2346 26.6812 22.6612Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.9467 59.7249H27.6503C27.441 59.7246 27.234 59.6815 27.042 59.5981C26.85 59.5148 26.6772 59.393 26.5341 59.2402C26.391 59.0875 26.2808 58.907 26.2102 58.71C26.1396 58.513 26.1101 58.3036 26.1235 58.0947C26.5382 51.9024 29.2905 46.099 33.8231 41.8597C38.3558 37.6204 44.3301 35.262 50.5363 35.262C56.7424 35.262 62.7167 37.6204 67.2494 41.8597C71.7821 46.099 74.5344 51.9024 74.949 58.0947C74.9626 58.3035 74.9332 58.513 74.8627 58.71C74.7923 58.9071 74.6821 59.0876 74.5391 59.2405C74.3962 59.3933 74.2234 59.5153 74.0315 59.5988C73.8395 59.6822 73.6325 59.7255 73.4232 59.7259H55.2007"
      fill="#E4F1FF"
    />
    <path
      d="M45.9467 59.7249H27.6503C27.441 59.7246 27.234 59.6815 27.042 59.5981C26.85 59.5148 26.6772 59.393 26.5341 59.2402C26.391 59.0874 26.2808 58.907 26.2102 58.71C26.1396 58.513 26.1101 58.3036 26.1235 58.0947C26.5382 51.9024 29.2905 46.099 33.8231 41.8597C38.3558 37.6204 44.3301 35.262 50.5363 35.262C56.7424 35.262 62.7167 37.6204 67.2494 41.8597C71.7821 46.099 74.5344 51.9024 74.949 58.0947C74.9626 58.3035 74.9332 58.513 74.8627 58.71C74.7923 58.9071 74.6821 59.0876 74.5391 59.2405C74.3962 59.3933 74.2234 59.5153 74.0315 59.5988C73.8395 59.6822 73.6325 59.7255 73.4232 59.7259H55.2007"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M57.8692 42.908C57.8692 42.908 47.0548 56.2311 46.3309 57.8908C46.0901 58.443 45.9604 59.0372 45.9493 59.6395C45.9381 60.2419 46.0457 60.8405 46.2659 61.4012C46.4861 61.9619 46.8146 62.4738 47.2327 62.9076C47.6507 63.3414 48.1501 63.6885 48.7023 63.9293C49.2545 64.1701 49.8487 64.2998 50.451 64.3109C51.0533 64.3221 51.6519 64.2145 52.2127 63.9943C52.7734 63.7741 53.2853 63.4456 53.719 63.0275C54.1528 62.6095 54.5 62.1102 54.7408 61.5579C55.4648 59.8982 57.8692 42.908 57.8692 42.908Z"
      fill="#D9EDE2"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M50.5359 38.3169V44.4328"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M65.6851 44.5757L61.3481 48.9117"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M70.3197 51.5298L64.6667 53.8711"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M35.3984 44.5874L39.7236 48.9116"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.3416 39.9412L44.6829 45.5931"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.7532 51.5298L36.4051 53.8711"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.0703 68.8992H38.303V75.016H26.0703V68.8992Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M44.4199 68.8992H56.6526V75.016H44.4199V68.8992Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M62.7695 68.8992H75.0023V75.016H62.7695V68.8992Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
